const RANKING_KEY = "embarca-log.dropoff_ranking";
const SEARCHED_LOCATIONS_KEY = "embarca-log.searched-locations";
const SEARCHED_MAX = 5;

export type DropoffRankingType = "origin" | "destination";

type DropoffRankingData = {
  origin: Record<string, number>;
  destination: Record<string, number>;
};

type SearchedLocationsData = {
  origin_ids: string[];
  destination_ids: string[];
};

function getRankingData(): DropoffRankingData {
  if (typeof window === "undefined") {
    return { origin: {}, destination: {} };
  }
  try {
    const raw = localStorage.getItem(RANKING_KEY);
    const data: DropoffRankingData = raw
      ? JSON.parse(raw)
      : { origin: {}, destination: {} };
    return {
      origin: data.origin && typeof data.origin === "object" ? data.origin : {},
      destination:
        data.destination && typeof data.destination === "object"
          ? data.destination
          : {},
    };
  } catch {
    return { origin: {}, destination: {} };
  }
}

function saveRankingData(data: DropoffRankingData): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(RANKING_KEY, JSON.stringify(data));
  } catch {}
}

export function incrementDropoffRanking(
  type: DropoffRankingType,
  id: number
): void {
  const data = getRankingData();
  const key = String(id);
  const map = data[type];
  map[key] = (map[key] || 0) + 1;
  saveRankingData(data);
}

function getSearchedLocationsData(): SearchedLocationsData {
  if (typeof window === "undefined") {
    return { origin_ids: [], destination_ids: [] };
  }
  try {
    const raw = localStorage.getItem(SEARCHED_LOCATIONS_KEY);
    const data: SearchedLocationsData = raw
      ? JSON.parse(raw)
      : { origin_ids: [], destination_ids: [] };
    return {
      origin_ids: Array.isArray(data.origin_ids) ? data.origin_ids : [],
      destination_ids: Array.isArray(data.destination_ids)
        ? data.destination_ids
        : [],
    };
  } catch {
    return { origin_ids: [], destination_ids: [] };
  }
}

function saveSearchedLocationsData(data: SearchedLocationsData): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(SEARCHED_LOCATIONS_KEY, JSON.stringify(data));
  } catch {}
}

export function addToSearchedLocations(
  type: DropoffRankingType,
  id: number
): void {
  const data = getSearchedLocationsData();
  const key = type === "origin" ? "origin_ids" : "destination_ids";
  const arr = data[key];
  const idStr = String(id);
  const filtered = arr.filter((x) => x !== idStr);
  const next = [idStr, ...filtered].slice(0, SEARCHED_MAX);
  data[key] = next;
  saveSearchedLocationsData(data);
}

export function getSearchedLocationIds(type: DropoffRankingType): string[] {
  const data = getSearchedLocationsData();
  const key = type === "origin" ? "origin_ids" : "destination_ids";
  return (data[key] || []).slice(0, SEARCHED_MAX);
}
